import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';

export default function I18n(props) {
  const {t, opts} = props;
  const [lang, setLang] = React.useState();
  const translation = React.useMemo(() => i18n.t(t, opts), [lang, t, opts]);
  React.useEffect(() => {
    i18n.addListener(setLang);
    return () => i18n.removeListener(setLang);
  }, []);

  return <>{translation}</>;
}

// convenience passthroughs
I18n.t = i18n.t;
I18n.addNamespace = i18n.addNamespace;

I18n.propTypes = {
  /** key to translate, passed to [i18mext.t(key, _)](https://www.i18next.com/overview/api#t) */
  t: PropTypes.string.isRequired,
  /** options, passed to [i18mext.t(_, options)](https://www.i18next.com/overview/api#t) */
  opts: PropTypes.object,
};
